// sessionStorage keys for client-authoritative SAGE history (Option C).
// sessionStorage (not localStorage) so history survives a page refresh /
// in-tab navigation but does not leak across tabs or persist after the tab
// closes. These are the single source of truth for the key names.
export const SS_THREAD_ID = 'sage_thread_id';
export const SS_RAW_MESSAGES = 'sage_raw_messages';       // Anthropic-format history sent to the gateway
export const SS_DISPLAY_MESSAGES = 'sage_display_messages'; // UI-rendered messages for continuity

// Drop all persisted SAGE conversation state. Called on New Chat, on an
// invalid_history reset, and on logout so a conversation never outlives the
// session (shared-computer / PII-at-rest concern).
export function clearSageSession() {
  try {
    sessionStorage.removeItem(SS_THREAD_ID);
    sessionStorage.removeItem(SS_RAW_MESSAGES);
    sessionStorage.removeItem(SS_DISPLAY_MESSAGES);
  } catch {
    // non-fatal
  }
}
